import PropTypes from "prop-types";
import React from "react";
import Loader from "shared/components/Loader";
import { useQuery } from "shared/hooks/useApi";
import graphql from "utils/api/graphql";
import { INITIAL_VALUES } from "../utils/constants";

const Tasks = ({ View, filter, ...props }) => {
  const variables = {
    ...filter,
    skip: parseInt(filter.skip) || INITIAL_VALUES.skip,
    take: parseInt(filter.take) || INITIAL_VALUES.take,
  };
  const query = useQuery(graphql.queries.TASKS, {
    variables,
    fetchPolicy: "cache-and-network",
  });
  const WrappedView = Loader(View);
  return (
    <WrappedView
      {...{
        ...props,
        ...query,
        type: "tasks",
      }}
    />
  );
};

Tasks.propTypes = {
  View: PropTypes.func.isRequired,
  filter: PropTypes.object,
};

Tasks.defaultProps = {
  filter: {},
};

export default React.memo(Tasks);
